import React from 'react'
import { NavLink } from 'react-router-dom'
import { Link as ReactScrollLink } from 'react-scroll'

import './index.scss'

import Button from '../Button'
import Container from '../Container'

import logo from '../../assets/logos/com-acordo-completo2.svg'
import facebook from '../../assets/social/facebook.svg'
import instagram from '../../assets/social/instagram.svg'
import linkedin from '../../assets/social/linkedin.svg'

const Footer = ({ type, options }) => {
  let email = 'contato@semprocesso.com.br'

  if (type === 'company') {
    email = 'comercial@semprocesso.com.br'
  }

  return (
    <Container>
      <div className="home-footer">
        <div className='home-footer__column'>
          <img src={logo} alt="Logo" />
        </div>
        <div className='home-footer__column'>
          <p>Sessões</p>
          {options.map(({ text, href, to, reactScroll }) => {
            if (reactScroll) return <p key={text}><ReactScrollLink to={to} spy={true} smooth={true} duration={500}>{text}</ReactScrollLink></p>
            if (href) return <p key={text}><a href={href} target='__blank'>{text}</a></p>
            return <p key={text}><NavLink to={to}>{text}</NavLink></p>
          })}
        </div>
        <div className='home-footer__column'>
          <p>Fale Conosco</p>
          <p><a href={`mailto:${email}`}>{email}</a></p>
          <p><a href="tel:2123911015">Atendimento (21) 2391-1015</a></p>
          {/* <p><a href="tel:11961730314">Comercial (11) 96173-0314</a></p> */}
          <p>Atendimento das 9h às 18h</p>
          <p></p>
        </div>
        <div className='home-footer__column'>
          <div className='home-footer__row'>
            {type === 'lawyer' &&
              <Button link margin="0 20px 0 0" padding="20px 30px" fontSize="16px" color="green" href="#How">Recebi um convite</Button>
            }
            {type === 'company' &&
              <Button link margin="0 20px 0 0" padding="20px 30px" fontSize="16px" color="green" href={`mailto:${email}`}>Entrar em Contato</Button>
            }
            <Button link href="/login" padding="20px 30px" fontSize="16px">Entrar</Button>
          </div>
          <div className='home-footer__logos'>
            <a href="https://pt-br.facebook.com/semprocesso/" target='_blank' rel="noopener noreferrer"><img src={facebook} alt="facebook" /></a>
            <a href="https://pt.linkedin.com/company/sem-processo" target='_blank' rel="noopener noreferrer"><img src={linkedin} alt="linkedin" /></a>
            <a href="https://www.instagram.com/semprocesso/" target='_blank' rel="noopener noreferrer"><img src={instagram} alt="instagram" /></a>
          </div>
          <div className='home-footer__row'>
            <div className='home-footer__column'>
              <span>Sem Processo S.A.</span>
              <span>Rua Marquês de São Vicente, 225 - 22451-900 - Gávea, RJ</span>
            </div>
          </div>
        </div>
      </div>
    </Container >
  )
}

export default Footer
